import { axiosApiClient, axiosPublicClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/radio";

class RadioService {
  // Javno, playlist za player (+ serverTime/anchor za "live" sinhronizaciju)
  getPlaylist = async () => {
    try {
      const response = await axiosPublicClient.get(`${BASE_URL}/playlist`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching radio playlist.");
    }
  };

  // Admin/DJ
  getTracks = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching radio tracks.");
    }
  };

  // requestData je FormData (audio fajl + polja) ili običan objekat sa audioUrl
  createTrack = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating radio track.");
    }
  };

  // ids u željenom redosledu, backend upiše sortOrder po poziciji
  reorderTracks = async (ids) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/reorder`, { ids });
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while reordering radio tracks.");
    }
  };

  updateTrack = async ({ id, requestData }) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}`,
        requestData,
      );
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating radio track.");
    }
  };

  toggleTrack = async (id) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${id}/toggle`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while toggling radio track.");
    }
  };

  deleteTrack = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting radio track.");
    }
  };
}

const radioService = new RadioService();
export default radioService;
